export type Props = {
    type: RedirectBlockType,
}
export enum RedirectBlockType {
    'wish' = 'wish',
    'users' = 'users'
}